import { useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Listbox } from '@headlessui/react'
import { FilterManager } from '@app/managers/filters'
import { DropDown } from './dropdown'
import { getActiveStyles } from '../general/cells/menu/styles'
import { CheckBox } from './checkbox'
import { useTranslation } from '@app/lib/hooks/useTranslation'

export const FilterList = observer(
  ({ allChecked }: { allChecked?: boolean }) => {
    const { t } = useTranslation('dashboard')
    const filterSize = FilterManager.filterList.length

    // todo: translate no items filtering
    if (!filterSize) {
      return (
        <div className='py-2 px-3 min-w-[160px] z-20 bg-white dark:bg-black text-sm md:max-w-[27.5vw]'>
          {t('filter-empty')}
        </div>
      )
    }

    return (
      <ul className='py-1 max-h-60 overflow-y-auto z-20 rounded bg-white dark:bg-black'>
        {filterSize ? (
          <Listbox.Option as={'li'} value={'all'}>
            {({ active }) => (
              <CheckBox
                name={t('all')}
                checked={allChecked}
                className={getActiveStyles(active)}
              />
            )}
          </Listbox.Option>
        ) : null}
        {FilterManager.filterList.map((item) => {
          return (
            <Listbox.Option key={item} as={'li'} value={item}>
              {({ active }) => (
                <CheckBox name={item} className={getActiveStyles(active)} />
              )}
            </Listbox.Option>
          )
        })}
      </ul>
    )
  }
)

export const FilterDropdown = ({
  open,
  right,
}: {
  open?: boolean
  right?: boolean
}) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]) // todo: use map instead of array
  const allChecked = useRef<boolean>(false)

  const setSelected = (pname: string[]) => {
    let containsAll = false

    // check removed items
    for (const item of selectedItems) {
      if (!pname.some((next) => next === item)) {
        FilterManager.toggleFilter(item)
      }
    }

    // check new items
    for (const item of pname) {
      if (item === 'all') {
        containsAll = true
      }
      if (!selectedItems.some((next) => next === item)) {
        FilterManager.toggleFilter(item)
      }
    }

    if (containsAll && !allChecked.current) {
      FilterManager.filterAll()
      // select all
      allChecked.current = true
    } else if (allChecked.current && !containsAll) {
      // perform de-select all
      FilterManager.unfilterAll()
      allChecked.current = false
    }

    setSelectedItems(pname)
  }

  return (
    <DropDown
      open={open}
      right={right}
      setSelected={setSelected}
      selectedItems={selectedItems}
    >
      <FilterList allChecked={allChecked.current} />
    </DropDown>
  )
}
